import sphereImage from './sphereCover.png'
import {
  Text,
  GreyGrey30,
  GreyGrey90,
  Image,
  ListItem,
  Primary13Regular,
  UnorderedList,
  Box,
  Flex
} from '@sequencehq/core-components'

export const SphereIntegrationDetail = () => {
  return (
    <Flex flexDirection="column" gap="20px">
      <Image
        src={sphereImage}
        width="100%"
        aspectRatio={1789 / 712}
        borderRadius="8px"
        border={`1px solid ${GreyGrey30}`}
        draggable={false}
      />
      <Text {...Primary13Regular} color={GreyGrey90}>
        Connect Sphere to calculate sales tax on your invoices based on your
        customer's location and tax legislation. This connector requires an
        account with Sphere.
      </Text>
      <Box {...Primary13Regular} color={GreyGrey90} lineHeight="18px">
        <UnorderedList>
          <ListItem>
            <strong>Automated tax calculations:</strong> Tax is calculated on
            every invoice
          </ListItem>
          <ListItem>
            <strong>Up-to-date tax rates:</strong> Sphere applies the correct
            rates per jurisdiction
          </ListItem>
          <ListItem>
            <strong>Customer and product sync:</strong> Customers and products
            sync to Sphere automatically
          </ListItem>
          <ListItem>
            <strong>Bi-directional sync:</strong> Keep Sequence and Sphere in
            sync
          </ListItem>
        </UnorderedList>
      </Box>
    </Flex>
  )
}
